import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import icons from "../../../assets/images/constantIcons";
import images from "../../../assets/images/constantImages";
import { useDispatch, useSelector } from "react-redux";
import { getCategoryDetails } from "./CategorySlice";
import { handleError } from "../../Common/ApiCommon/ApiService";
import { addItem } from "./ItemsSlice";


const AddItemsForm = ({ isOpen, onClose }) => {
  const [isToggle, setIsToggle] = useState(false);
  const dispatch = useDispatch();
  const { data, loading } = useSelector((state) => state.categories);

  useEffect(() => {
    dispatch(getCategoryDetails());
  }, [dispatch]);

  const handleTogleSwitch = () => {
    setIsToggle((prev) => {
      const newToggle = !prev;
      formik.setFieldValue("stock_available", newToggle);
      return newToggle;
    });
  };

  const meal_type = ["vegeterian", "non-vegeterian", "vegan"]

  const formik = useFormik({
    initialValues: {
      canteen_category_id: "",
      name: "",
      price: "",
      meal_type: "",
      stock_available: false,
      image: null,
      imagePreview: null,
    },
    validationSchema: Yup.object({
      canteen_category_id: Yup.string().required("Category is required"),
      meal_type: Yup.string().required("Meal type is required"),
      name: Yup.string().required("Item name is required"),
      price: Yup.number().typeError("Price must be a number").positive("Must be positive").required("Price is required"),
      image: Yup.mixed().required("Product image is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        const formData = new FormData();
        formData.append("item[canteen_category_id]", values.canteen_category_id);
        formData.append("item[name]", values.name);
        formData.append("item[price]", values.price);
        formData.append("item[meal_type]", values.meal_type);
        formData.append("item[stock_available]", isToggle);
        formData.append("item[image]", values.image);

        const response= await dispatch(addItem(formData)).unwrap();
       
        
        onClose();
        toast.success("Item added successfully!", { duration: 2000 });
        resetForm()
      } catch (errors) {
        handleError(errors);
      }
    },
  });

  useEffect(() => {
    setIsToggle(formik.values.stock_available);
  }, [formik.values.stock_available]);

  if (loading) return <p>Loading ...</p>
  return (
    isOpen && (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg p-4 s:p-6 w-[310px] s:w-[350px] md:w-[460px] relative">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-lg font-semibold">Add New Item</h2>
            <div
              className="absolute top-7 right-3 bg-green50 rounded-full p-2 cursor-pointer w-[32px] h-[32px]"
              onClick={onClose}
            >
              <icons.IoClose className="text-green700" />
            </div>
          </div>

          <form onSubmit={formik.handleSubmit} className="space-y-4 h-[70vh] overflow-y-auto vertical">
            {/* Category */}
            <div className="text-G300">
              <label className="block text-sm font-normal mb-2">Category</label>
              <select
                name="canteen_category_id"
                value={formik.values.canteen_category_id}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className="inputtext"
              >
                <option value="">Select a category</option>
                {data?.map((category) => (
                  <option key={category.id} value={category.id}>
                    {category.name}
                  </option>
                ))}
              </select>
              {formik.touched.canteen_category_id && formik.errors.canteen_category_id && (
                <div className="text-red text-sm">{formik.errors.canteen_category_id}</div>
              )}
            </div>

            {/* Name and Price */}
            <div className="grid grid-cols-2 gap-3">
              <div className="text-G300">
                <label className="block text-sm font-normal mb-2">Item name</label>
                <input
                  type="text"
                  name="name"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="inputtext"
                  placeholder="Sicilian pizza"
                />
                {formik.touched.name && formik.errors.name && (
                  <div className="text-red text-sm">{formik.errors.name}</div>
                )}
              </div>
              <div className="text-G300">
                <label className="block text-sm font-normal mb-2">Price</label>
                <div className="relative">
                  <span className="absolute inset-y-0 left-3 flex items-center text-green font-semibold">₹</span>
                  <input
                    type="number"
                    name="price"
                    placeholder="15"
                    value={formik.values.price}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className="inputtext text-green"
                    style={{ paddingLeft: "25px" }}
                  />
                </div>
                {formik.touched.price && formik.errors.price && (
                  <div className="text-red text-sm">{formik.errors.price}</div>
                )}
              </div>
            </div>


            {/* Product Image Upload */}
            <div className="text-G300">
              <label className="block text-sm font-normal mb-2">Product Image</label>
              <div
                className="flex gap-3 items-center cursor-pointer w-20"
                onClick={() => document.getElementById('fileInput').click()}
              >
                <img
                  src={formik.values.imagePreview || images.downloadimage}
                  alt="Product Preview"
                  className="w-12 h-12 object-cover rounded "
                />
                <p>Upload</p>
              </div>
              <input
                id="fileInput"
                type="file"
                accept="image/*"
                hidden
                onChange={(e) => {
                  const file = e.currentTarget.files[0];
                  if (file) {
                    formik.setFieldValue("image", file);
                    formik.setFieldValue("imagePreview", URL.createObjectURL(file));
                    formik.validateField("image");
                  }
                }}
              />
              {formik.touched.image && formik.errors.image && (
                <div className="text-red text-sm">{formik.errors.image}</div>
              )}
            </div>

            {/* Meal Type */}
            <div className="text-G300">
              <label className="block text-sm font-normal mb-2">Meal Type</label>
              <select
                name="meal_type"
                value={formik.values.meal_type}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className="inputtext"
              >
                <option value="">Select a type</option>
                {meal_type.map((cat, i) => (
                  <option key={i} value={cat}>{cat}</option>
                ))}
              </select>
              {formik.touched.meal_type && formik.errors.meal_type && (
                <div className="text-red text-sm">{formik.errors.meal_type}</div>
              )}
            </div>
            {/* Toggle Switch */}
            <div className="text-G300">
              <label className="block text-sm font-normal mb-2">Stock available</label>
              <div className="cursor-pointer" onClick={handleTogleSwitch}>
                {isToggle ? (
                  <img src={images.ontogleswitch} alt="ontogleswitch" />
                ) : (
                  <img src={images.offtogleswitch} alt="offtogleswitch" />
                )}
              </div>
            </div>
   {/* button  */}
             <button
              type="submit"
              disabled={formik.isSubmitting}
              className={`w-full mt-6 h-11 text-lg text-center py-2 rounded-lg font-semibold transition-all ${formik.isSubmitting
                  ? "bg-green200 cursor-not-allowed"
                  : "bg-green text-white hover:bg-green700"
                }`}
            >
              {formik.isSubmitting ? "Adding..." : "Add New Item"}
            </button>
          </form>
        </div>
      </div>
    )
  );
};

export default AddItemsForm;

